import { TablePagination } from '@all-manager/design-system-v2';
import { PER_PAGE_OPTIONS } from '../../pages/useTopicListPage';

type Props = {
  count: number;
  /** 1-based, as stored in the URL. */
  page: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
};

function formatDisplayedRows(info: { from: number; to: number; count: number }) {
  return `${info.from}–${info.to} sur ${info.count}`;
}

export default function TopicsPagination(props: Props) {
  return (
    <TablePagination
      count={props.count}
      page={props.page - 1}
      rowsPerPage={props.rowsPerPage}
      rowsPerPageOptions={PER_PAGE_OPTIONS}
      onPageChange={(page) => props.onPageChange(page + 1)}
      onRowsPerPageChange={props.onRowsPerPageChange}
      labelRowsPerPage="Par page"
      labelDisplayedRows={formatDisplayedRows}
      getItemAriaLabel={(type) => (type === 'next' ? 'Page suivante' : 'Page précédente')}
    />
  );
}
